import { Stack, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import React from 'react';

import { Neutrals } from '../../color-palette/colors';

import { PROSE_MAX } from './screenLayout';

export interface SectionHeadingProps {
  label: string;
  id?: string;
  description?: React.ReactNode;
  count?: React.ReactNode;
  headingLevel?: 'h2' | 'h3';
  children: React.ReactNode;
}

const labelSx = (theme: Theme): SystemStyleObject<Theme> => ({
  '&:lang(hi)': {
    letterSpacing: 0,
    textTransform: 'none',
    fontSize: theme.typography.caption2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
  },
});
const countSx = { color: Neutrals[600], fontVariantNumeric: 'tabular-nums' } as const;
const descriptionSx = { color: Neutrals[600], maxWidth: PROSE_MAX } as const;
const titleRowSx = { minWidth: 0 } as const;

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  label,
  id,
  description,
  count,
  headingLevel = 'h2',
  children,
}) => (
  <Stack spacing={2}>
    <Stack spacing={1}>
      <Stack direction="row" alignItems="baseline" spacing={2} sx={titleRowSx}>
        <Typography id={id} variant="sectionLabel" component={headingLevel} sx={labelSx}>
          {label}
        </Typography>
        {count !== undefined && count !== null && (
          <Typography component="span" variant="caption2" sx={countSx}>
            {count}
          </Typography>
        )}
      </Stack>
      {description !== undefined && description !== null && (
        <Typography variant="label" component="p" sx={descriptionSx}>
          {description}
        </Typography>
      )}
    </Stack>
    {children}
  </Stack>
);
